import { createPageEntryPoint } from '@atlassian/jira-create-route-entry-point/src/index.tsx';
import { MENU_ID } from '@atlassian/jira-navigation-apps-common/src/constants.tsx';
import { helpCenterSettingsPhoneConfigurationAppEntryPoint as main } from '@atlassian/jira-spa-apps-help-center-settings-phone-configuration/entrypoint.tsx';

export const HelpCenterSettingsPhoneConfigurationEntryPoint = createPageEntryPoint({
	main,
	topNavigationMenuId: MENU_ID.HELP_CENTER_SETTINGS,
});
